import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'parties_to_the_cba_that_covers_the_greatest_num_of_wrkrs_in_the'

export const dataPointDefinition = {
  retracedId: 'parties_to_the_cba_that_covers_the_greatest_num_of_wrkrs_in_the',
  name: 'Parties to the CBA that covers the greatest number of workers in the workplace:',
  description:
    "If more than one CBA covers the same (greatest) number of workers, indicate the parties to the CBA with the longest duration first and use the next set of questions for the other CBA. \r\r\n\r\r\nFor a CBA(s) beyond enterprise level, indicate the employers' and workers' organizations that are parties to the CBA. For an enterprise level CBA, indicate the name of the employer/company and the union(s) that are parties to the CBA.",
  meta: {},
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-40',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12340,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
